export enum SituacaoTransferencia {
  Aberta = 'Aberta',
  Finalizada = 'Finalizada',
  Cancelada = 'Cancelada'
}
